import { Component, EventEmitter, Input, NgZone, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { forkJoin } from 'rxjs';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CityService } from '../../services/city.service';
import { ContactService } from '../../services/contact.service';
import { CSEService } from '../../services/cse.service';
import { EmployeeService } from '../../services/employees.service';
import { FileService } from '../../services/file.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { UtilService } from '../../services/util.service';
import {
    APIResponse,
    Carrier,
    City,
    CarrierContract,
    Employee,
    MacropointGoodTruck,
    MacropointLocationProvider,
    MacropointOrder,
    MacropointTrackingOption,
    OrderStop,
    QuoteOrderLine,
    SearchCarrierContact,
    SearchCityState,
    SearchOffer,
    SearchQuoteOrderLine
} from '../../models/models';

@Component({
    selector: 'carrier-contract-form',
    templateUrl: './carrier-contract-form.component.html',
    standalone: false
})
export class CarrierContractForm implements OnInit, OnChanges {
    @Input() carrierContractID: number = 0;
    @Input() masterQuoteOrderLineID: number = 0;
    @Input() quoteOrderLineID: number = 0;
    @Output() onRefresh = new EventEmitter<any>();

    public isAddOffer: boolean = false;
    public carrierContract: CarrierContract = {} as CarrierContract;
    public offer: SearchOffer = {} as SearchOffer;
    private quoteOrderLine: QuoteOrderLine = {} as QuoteOrderLine;
    private searchQuoteOrderLine: SearchQuoteOrderLine = {} as SearchQuoteOrderLine;
    private carrier: Carrier = {} as Carrier;
    private orderStops: OrderStop[] = [];
    private pickupStop: OrderStop = {} as OrderStop;
    //private dropStop: OrderStop = {} as OrderStop;

    public carrierReps: Employee[] = [];
    private carrierRepsFilter: any[] = [];
    private carrierContacts: SearchCarrierContact[] = [];
    private contacts: SearchCarrierContact[] = [];
    private drivers: SearchCarrierContact[] = [];
    public selectedContact: SearchCarrierContact = {} as SearchCarrierContact;
    public selectedDriver: SearchCarrierContact = {} as SearchCarrierContact;
    public selectedDriver2: SearchCarrierContact = {} as SearchCarrierContact;
    public isAddDispatcher: boolean = false;
    public isAddDriver1: boolean = false;
    public isAddDriver2: boolean = false;
    public isEditDispatcher: boolean = false;
    public isEditDriver1: boolean = false;
    public isEditDriver2: boolean = false;
    public countryCode: string = "US";

    public beginTrackingDate: Date = new Date();
    public endTrackingDate: Date = new Date();
    public goodTruckEquipmentID: string = "";
    private macropointOrder: MacropointOrder = {} as MacropointOrder;
    public macropointGoodTruckList: MacropointGoodTruck[] = [];
    public macropointTrackingOptionsAll: MacropointTrackingOption[] = [];
    public macropointTrackingOptions: MacropointTrackingOption[] = [];
    public macropointLocationProviders: MacropointLocationProvider[] = [];
    public macropointTrackInterval: number = 0;
    public macropointLocationProviderId: number = 0;
    public macropointLocationProviderDevice: string = "";
    public macropointEmails: string = "";

    //public isCRMAdmin: boolean = false;
    public isValid: boolean = true;
    public validationWarningList: string[] = [];

    public ppcCity: City = {} as City;
    public defaultPPCCity: string = "";
    public ppcCityControl = new UntypedFormControl();
    public carrierContractForm: UntypedFormGroup = new UntypedFormGroup({
        ppcCityStateZipCtrl: new UntypedFormControl(''),
        ppcCityControl: new UntypedFormControl('')
    });

    constructor(private fileService: FileService,
        private cityService: CityService,
        private contactService: ContactService,
        private cseService: CSEService,
        private employeeService: EmployeeService,
        private notificationService: NotificationService,
        private orderService: OrderService,
        private utilService: UtilService) {
    }

    ngOnInit() {
        //this.isCRMAdmin = this.getIsCRMAdmin();
        //console.log("ngOnInit", this.carrierContractID);
        this.getCarrierReps();
    }

    ngOnChanges() {
        this.getCarrierContract();
    }

    private getCarrierContract() {
        if (this.carrierContractID > 0) {
            this.cseService.getCarrierContractByID(this.carrierContractID).subscribe(result => {
                this.carrierContract = result.resultCollection[0];
                this.carrierContract.startDate = new Date(this.carrierContract.startDate);
                if (this.carrierContract.expirationDate != null) {
                    this.carrierContract.expirationDate = new Date(this.carrierContract.expirationDate);
                }
                if (this.carrierContract.csrTeamIDs != null && this.carrierContract.csrTeamIDs != "") {
                    var strValues: string[] = this.carrierContract.csrTeamIDs.split(",");
                    var numValues: number[] = strValues.map(Number);
                    this.carrierRepsFilter = numValues;
                    console.log("getCarrierContract", this.carrierContract.csrTeamIDs, strValues, numValues);
                }
                this.setDefaultPPCCity();
                this.cseService.getSearchOfferByID(this.carrierContract.masterOfferID).subscribe(result => {
                    var offer = result.resultCollection[0];
                    this.setContract(offer);
                });
            });
        }
        else {
            this.carrierContract.masterQuoteOrderLineID = this.quoteOrderLineID;
            this.carrierContract.startDate = new Date();
            this.carrierContract.expirationDate = this.utilService.addDays(new Date(), 30);
            this.carrierContract.createdByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
        }
    }

    public setContract(offer: SearchOffer) {
        this.offer = offer;

        if (!this.carrierContract.carrierContractID) {
            this.carrierContractID = 0;
            this.carrierContract.carrierContractID = 0;
            this.carrierContract.masterQuoteOrderLineID = this.quoteOrderLineID;
            this.carrierContract.masterOfferID = offer.offerID;
            this.carrierContract.ppcCityID = offer.originCityID;
            this.carrierContract.offerRate = offer.offerRate;
            this.carrierContract.offerRatePerMile = offer.offerRatePerMile;
            this.carrierContract.startDate = new Date();
            this.carrierContract.expirationDate = this.utilService.addDays(new Date(), 30);
            this.carrierContract.createdByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
        }
        else {
            this.carrierContract.startDate = new Date(this.carrierContract.startDate);
            if (this.carrierContract.expirationDate != null) {
                this.carrierContract.expirationDate = new Date(this.carrierContract.expirationDate);
            }
            this.carrierContract.lastModifiedByEmployeeID = parseInt(localStorage.getItem('EmployeeId')!);
        }

        var getCarrier = this.cseService.getCarrierByID(this.offer.carrierID);
        var getSearchQuoteOrderLine = this.orderService.getSearchQuoteOrderLineByID(this.quoteOrderLineID);
        var getQuoteOrderLine = this.orderService.getQuoteOrderLineById(this.quoteOrderLineID);
        var getOrderStops = this.orderService.getOrderStopsByLineId(this.quoteOrderLineID);

        this.utilService.isLoading = true;

        forkJoin([getCarrier, getSearchQuoteOrderLine, getQuoteOrderLine, getOrderStops]).subscribe(result => {
            this.utilService.isLoading = false;

            this.setCarrier(result[0]);
            this.setSearchQuoteOrderLine(result[1]);
            this.setQuoteOrderLine(result[2]);
            this.setOrderStops(result[3]);

            this.getContacts();
            this.setTrackingDates();
            this.setDefaultPPCCity();
            this.getMacropointLocationProviders();

            this.validate(true);
        });

        console.log("setContract", this.carrierContract, offer);
    }

    private setCarrier(result: APIResponse) {
        this.carrier = result.resultCollection[0];
        this.macropointLocationProviderId = this.carrier.macropointLocationProviderId;
        this.cityService.getSearchCityStateByCityID(this.carrier.cityID).subscribe(result => {
            var city: SearchCityState = result.resultCollection[0];
            this.countryCode = (city.countryAbbr.trim() == "MX" ? "MX" : "US");
        });
    }

    private setSearchQuoteOrderLine(result: APIResponse) {
        this.searchQuoteOrderLine = result.resultCollection[0];
    }

    private setQuoteOrderLine(result: QuoteOrderLine) {
        this.quoteOrderLine = result;
        this.quoteOrderLine.carrierID = this.offer.carrierID;
    }

    private setOrderStops(result: APIResponse) {
        this.orderStops = result.resultCollection;
        var stops: OrderStop[] = result.resultCollection;
        stops = stops.sort((left, right): number => {
            if (left.stopSequence < right.stopSequence) return -1;
            if (left.stopSequence > right.stopSequence) return 1;
            return 0;
        });
        var stop = this.orderStops.filter(s => s.eventCode == "HLT" || s.eventCode == "LLD");
        if (stop.length > 0) {
            this.pickupStop = stop[0];
            var pickupEarliestDate: Date = new Date(this.pickupStop.earliestDate);
            var pickupLatestDate: Date = new Date(this.pickupStop.latestDate);
            //this.ppcDate = new Date(this.pickupStop.earliestDate);
            //this.ppcDateUTC = new Date(this.pickupStop.earliestDateUTC);
            //this.ppcDate.setTime(this.ppcDate.getTime() - 2 * 60 * 60 * 1000);
            //this.ppcDateUTC.setTime(this.ppcDateUTC.getTime() - 2 * 60 * 60 * 1000);
            //this.firstPickupEarliestDate = pickupEarliestDate; //firstPickup.ArrivalDate.Value.TimeOfDay;
            //this.firstPickupLatestDate = pickupLatestDate; //firstPickup.ArrivalDate.Value.TimeOfDay;
            //if (pickupEarliestDate < this.minFirstPickupEarliestDate) {
            //    this.minFirstPickupEarliestDate = pickupEarliestDate;
            //}
        }
        //stop = this.orderStops.filter(s => s.eventCode == "DLT" || s.eventCode == "LUL");
        //if (stop.length > 0) {
        //    this.dropStop = stop[stop.length - 1];
        //}
    }

    private getCarrierReps() {
        this.employeeService.getEmployeesByGroupName('CarrierRep').subscribe(result => {
            var emps = result;
            emps = emps.sort((left, right): number => {
                if (left.fullName < right.fullName) return -1;
                if (left.fullName > right.fullName) return 1;
                return 0;
            });
            for (var i = 0; i < emps.length; i++) {
                emps[i].winUserName = (emps[i].winUserName == null ? "" : emps[i].winUserName.toUpperCase());
            }
            this.carrierReps = emps;
        });
    }

    private getContacts() {
        this.utilService.isLoading = true;
        this.contactService.getSearchContactByCarrierID(this.offer.carrierID).subscribe(result => {
            this.utilService.isLoading = false;
            this.carrierContacts = result.resultCollection;
            this.contacts = this.carrierContacts.filter(c => c.contactTitleDesc.toLowerCase().trim() != "driver");
            this.drivers = this.carrierContacts.filter(c => c.contactTitleDesc.toLowerCase().trim() == "driver");
            this.initContacts();
            //console.log("getContacts", this.contacts, this.drivers);
        });
    }

    private initContacts() {
        if (this.quoteOrderLine.carrierContactId != null) {
            this.selectedContact = this.contacts.find(c => c.contactID == this.quoteOrderLine.carrierContactId)! || {} as SearchCarrierContact;
        }
        if (this.quoteOrderLine.driverId != null) {
            this.selectedDriver = this.drivers.find(c => c.contactID == this.quoteOrderLine.driverId)! || {} as SearchCarrierContact;
        }
        if (this.quoteOrderLine.driver2Id != null) {
            this.selectedDriver2 = this.drivers.find(c => c.contactID == this.quoteOrderLine.driver2Id)! || {} as SearchCarrierContact;
        }
        this.validate(true);
        //console.log("initContacts", this.selectedContact, this.selectedDriver, this.selectedDriver2);
    }

    public contactChange(evt: any) {
        //console.log("contactChange", evt.target.value, this.offer.quoteOrderLine.carrierContactId);
        var contactID = evt.target.value;
        if (contactID != "") {
            this.selectedContact = this.contacts.find(c => c.contactID == contactID)!;
            this.quoteOrderLine.carrierContactId = contactID;
        }
        else {
            this.selectedContact = {} as SearchCarrierContact;
        }
        if (this.selectedContact.phone == undefined) {
            this.selectedContact.phone = "";
        }
        if (this.selectedContact.email == undefined) {
            this.selectedContact.email = "";
        }
        this.validate(true);
    }

    public addContact(contactType) {
        if (contactType == "Dispatcher") {
            this.isAddDispatcher = true;
        }
        if (contactType == "Driver1") {
            this.isAddDriver1 = true;
        }
        if (contactType == "Driver2") {
            this.isAddDriver2 = true;
        }
    }

    public editContact(contactType) {
        if (contactType == "Dispatcher") {
            this.isEditDispatcher = true;
        }
        if (contactType == "Driver1") {
            this.isEditDriver1 = true;
        }
        if (contactType == "Driver2") {
            this.isEditDriver2 = true;
        }
    }

    public refreshContacts(contactID: number, contactType: string) {
        if (contactType == "Dispatcher") {
            this.isAddDispatcher = false;
            this.isEditDispatcher = false;
            this.quoteOrderLine.carrierContactId = contactID;
        }
        else if (contactType == "Driver1") {
            this.isAddDriver1 = false;
            this.isEditDriver1 = false;
            this.quoteOrderLine.driverId = contactID;
        }
        else if (contactType == "Driver2") {
            this.isAddDriver2 = false;
            this.isEditDriver2 = false;
            this.quoteOrderLine.driver2Id = contactID;
        }
        //console.log("refreshContacts", contactID, contactType);
        this.getContacts();
    }

    public driverChange(evt: any, num: number) {
        //console.log("driverChange", evt, evt.target.value, num);
        var contactID = evt.target.value;
        if (contactID != "") {
            if (num == 2) {
                this.selectedDriver2 = this.drivers.find(c => c.contactID == contactID)!;
                this.quoteOrderLine.driver2Id = this.selectedDriver2.contactID;
            }
            else {
                this.selectedDriver = this.drivers.find(c => c.contactID == contactID)!;
                this.quoteOrderLine.driverId = this.selectedDriver.contactID;
            }
        }
        else {
            if (num == 2) {
                this.selectedDriver2 = {} as SearchCarrierContact;
            }
            else {
                this.selectedDriver = {} as SearchCarrierContact;
            }
        }
        if (this.selectedDriver.cell == undefined) {
            this.selectedDriver.cell = "";
        }
        if (this.selectedDriver2.cell == undefined) {
            this.selectedDriver2.cell = "";
        }
        this.validate(true);
    }

    public carrierRepsChange(values: any[]): void {
        console.log("carrierRepsChange", values);
        this.carrierRepsFilter = values;
        var valMap = values.map(value => ({
            field: "csr",
            operator: "eq",
            value
        }));

        var strValues: string = values.join(",");
        this.carrierContract.csrTeamIDs = strValues;
        //console.log("carrierRepsChange", valMap, this.carrierRepsFilter, strValues);
    }

    public ppcCitySTChanged(evt: any, isDefault: boolean) {
        var cityID = evt;
        this.utilService.isLoading = true;
        this.cityService.getCityByID(cityID).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                this.ppcCity = result.resultCollection[0];
                this.carrierContract.ppcCityID = cityID;
                this.validate(false);
            }
            else {
                this.notificationService.showWarning("Invalid or missing city.", "WARNING: Invalid City");
            }
        });
    }

    private setDefaultPPCCity() {
        this.utilService.isLoading = true;
        this.cityService.getCityByID(this.carrierContract.ppcCityID).subscribe(result => {
            this.utilService.isLoading = false;
            if (result.resultCollection.length > 0) {
                var city = result.resultCollection[0] as City;
                this.defaultPPCCity = city.cityST;
                this.ppcCity = city;
                this.ppcCitySTChanged(city.cityID, true);
            }
        });
    }

    public calcRate(rateType) {
        if (this.quoteOrderLine.miles > 0) {
            if (rateType == "offerRate") {
                this.carrierContract.offerRatePerMile = parseFloat((this.carrierContract.offerRate / this.quoteOrderLine.miles).toFixed(2));
            }
            else if (rateType == "offerRatePerMile") {
                this.carrierContract.offerRate = parseFloat((this.carrierContract.offerRatePerMile * this.quoteOrderLine.miles).toFixed(2));
            }
        }
        this.validate(false);
    }

    public dateChanged(field: string) {
        if (this.carrierContract.expirationDate != null) {
            if (field == "startDate" && this.carrierContract.startDate > this.carrierContract.expirationDate) {
                this.carrierContract.expirationDate = this.carrierContract.startDate;
            }
            else if (field == "expirationDate" && this.carrierContract.startDate > this.carrierContract.expirationDate) {
                this.carrierContract.startDate = this.carrierContract.expirationDate;
            }
        }
        this.validate(false);
    }

    private getMacropointLocationProviders() {
        this.utilService.isLoading = true;
        this.orderService.getMacropointLocationProviders().subscribe(result => {
            this.utilService.isLoading = false;
            this.macropointLocationProviders = result;
            this.getMacropointTrackingOptions();
            this.getMacropointGoodTrucks(false);
            //if (this.offer.isAwarded == true) {
            //    this.setMacropointOrderData();
            //}
            this.setMacropointOrderData();
        });
    }

    private getMacropointTrackingOptions() {
        this.utilService.isLoading = true;
        this.orderService.getMacropointTrackingOptions().subscribe(result => {
            this.utilService.isLoading = false;
            this.macropointTrackingOptionsAll = result;
            var option = result.find(p => p.macropointTrackingOptionID == this.macropointLocationProviderId);
            this.filterMacropointLocationProvider(option!.locationProvider);
            this.macropointLocationProviderChange(this.macropointLocationProviderId);
        });
    }

    private filterMacropointLocationProvider(provider: string) {
        var options: MacropointTrackingOption[] = [];
        if (provider == "") {
            options = Object.assign([], this.macropointTrackingOptionsAll);
        }
        else {
            options = this.macropointTrackingOptionsAll.filter(t => t.locationProvider == provider);
        }
        this.macropointTrackingOptions.length = 0;
        for (var i = 0; i < options.length; i++) {
            if (this.macropointTrackingOptions.findIndex(o => o.locationProvider == options[i].locationProvider && o.trackInterval == options[i].trackInterval && o.trackAmount == options[i].trackAmount) < 0) {
                this.macropointTrackingOptions.push(options[i]);
            }
        }
    }

    public macropointLocationProviderChange(evt: any) {
        //console.log("macropointLocationProviderChange", evt);
        var providerID = 0;
        if (!isNaN(evt) && evt != null && evt > 0) {
            providerID = evt;
        }
        else {
            providerID = evt.target.value;
        }
        var trackVia: MacropointLocationProvider | undefined;
        if (providerID > 0) {
            trackVia = this.macropointLocationProviders.find(t => t.macropointLocationProviderId == providerID);
            if (trackVia != null) {
                this.macropointLocationProviderDevice = trackVia.trackType;
                this.filterMacropointLocationProvider(trackVia!.provider);
            }
        }
        //console.log("macropointLocationProviderChange", this.macropointLocationProviderDevice);
        this.validate(true);
    }

    private setMacropointOrderData() {
        // Editing awarded offer, so get MacropointOrder if it exists
        if (this.quoteOrderLine.macropointOrderId > 0) {
            this.orderService.getMacropointOrderByID(this.quoteOrderLine.macropointOrderId).subscribe(result => {
                if (result.resultCollection.length > 0) {
                    this.macropointOrder = result.resultCollection[0];
                    // Override carrier default with actual order
                    this.macropointLocationProviderId = this.macropointOrder.macropointLocationProviderId;
                    this.macropointLocationProviderChange(this.macropointLocationProviderId);
                    var truckNumber = this.quoteOrderLine.truckNumber;
                    if (truckNumber != null && truckNumber != "" && this.macropointLocationProviders.length > 0) {
                        if (this.macropointGoodTruckList.length > 0) {
                            var goodTruck = this.macropointGoodTruckList.find(t => t.equipmentID == truckNumber);
                            if (goodTruck == null) {
                                this.goodTruckEquipmentID = "- Other -";
                            }
                            else {
                                this.goodTruckEquipmentID = goodTruck.equipmentID;
                            }
                        }
                    }
                }
            });
        }
        else {
            this.macropointOrder.macropointOrderId = 0;
            this.macropointOrder.quoteOrderLineId = this.quoteOrderLineID;
            this.macropointOrder.carrierId = this.quoteOrderLine.carrierID;
            this.macropointOrder.orderId = "";
            this.macropointOrder.macropointLocationProviderId = this.macropointLocationProviderId;
            this.macropointOrder.trackStartDate = this.beginTrackingDate;
            var trackDuration = this.utilService.getDateDiffHours(this.beginTrackingDate, this.endTrackingDate);
            this.macropointOrder.trackDurationHours = Math.round(trackDuration);
            var trackingOption = this.macropointTrackingOptions.find(t => t.macropointTrackingOptionID == this.macropointTrackInterval);
            if (trackingOption != null) {
                this.macropointOrder.trackIntervalMinutes = trackingOption!.trackInterval;
            }
            this.macropointOrder.notes = "Order #" + this.searchQuoteOrderLine.orderNumber + " - " + this.searchQuoteOrderLine.originCityStateZip + " to " + this.searchQuoteOrderLine.destinationCityStateZip;
            if (this.macropointEmails == "") {
                this.macropointOrder.emails = "alsmacro@automatedlogistics.com";
            }
            else {
                this.macropointOrder.emails = this.macropointEmails;
            }
            this.macropointOrder.stoppedInd = false;
            this.macropointOrder.changedInd = false;
            this.macropointOrder.createByEmployeeId = parseInt(localStorage.getItem('EmployeeId')!);
        }
        console.log("setMacropointOrderData", this.macropointOrder.macropointOrderId, this.macropointOrder);
    }

    private getMacropointGoodTrucks(isRefresh: boolean) {
        this.utilService.isLoading = true;
        this.orderService.getMacropointGoodTrucksByCarrierID(this.offer.carrierID, isRefresh).subscribe(result => {
            this.utilService.isLoading = false;
            this.macropointGoodTruckList = result.resultCollection;
        });
    }

    public macropointGoodTruckChange(evt: any) {
        if (evt != null) {
            var truckNumber: string = evt.target.value;
            if (truckNumber != '- Other -') {
                this.quoteOrderLine.truckNumber = evt.target.value;
            }
            else {
                this.quoteOrderLine.truckNumber = "";
            }
        }
        //console.log("macropointGoodTruckChange", evt);
    }

    private setTrackingDates() {
        if (this.pickupStop.arrivalDateUTC != null) {
            // Use pickup stop arrival date and convert to UTC
            var isPast: boolean = false;
            var pickupDate: Date = new Date(this.pickupStop.arrivalDateUTC);
            var nowDate: Date = this.utilService.getLocalDateInUTC(new Date());
            // Check if date is in past and add 5min to "now" if so
            if (nowDate > pickupDate) {
                isPast = true;
                pickupDate = this.utilService.addMinutes(nowDate, 5);
            }

            pickupDate = new Date(this.utilService.getUTCDateAsLocalDate(pickupDate));

            this.beginTrackingDate = pickupDate;
            if (!isPast) {
                this.beginTrackingDate.setTime(pickupDate.getTime() - 3 * 60 * 60 * 1000);
            }
        }
        if (this.searchQuoteOrderLine.deliveryDate != null) {
            // Use last stop DepartDateUTC instead of line.OriginalDeliveryDate
            var deliveryDate: Date = new Date(this.searchQuoteOrderLine.deliveryDate);
            this.endTrackingDate = deliveryDate;
            this.endTrackingDate.setTime(deliveryDate.getTime() + 8 * 60 * 60 * 1000);
        }
    }

    private validate(isMacropoint: boolean) {
        this.isValid = true;
        this.validationWarningList.length = 0;
        if (this.selectedContact.email == null || this.selectedContact.email == "") {
            this.isValid = false;
            this.validationWarningList.push("Contact email required.");
        }
        if (isMacropoint == true && this.macropointLocationProviderDevice == "Mobile" && (this.selectedDriver.cell == null || this.selectedDriver.cell == "")) {
            this.isValid = false;
            this.validationWarningList.push("Driver Cell required.");
        }
        if (isMacropoint == true && this.macropointLocationProviderDevice == "VehicleID" && (this.quoteOrderLine.truckNumber == null || this.quoteOrderLine.truckNumber == "")) {
            this.isValid = false;
            this.validationWarningList.push("Truck # required.");
        }
        if (isMacropoint == true && this.macropointLocationProviderDevice == "TrailerID" && (this.quoteOrderLine.trailerNumber == null || this.quoteOrderLine.trailerNumber == "")) {
            this.isValid = false;
            this.validationWarningList.push("Trailer # required.");
        }
        if (!this.quoteOrderLine.awardedCarrierRepId) {
            this.isValid = false;
            this.validationWarningList.push("Carrier Rep required.");
        }
        if (!this.ppcCity.cityID) {
            this.isValid = false;
            this.validationWarningList.push("PPC City required.");
        }
        if (this.carrierContract.startDate == null) {
            this.isValid = false;
            this.validationWarningList.push("Start date required.");
        }
        if (this.carrierContract.expirationDate == null) {
            this.isValid = false;
            this.validationWarningList.push("Expiration date required.");
        }
        if (this.carrierContract.offerRate == null || this.carrierContract.offerRate <= 0) {
            this.isValid = false;
            this.validationWarningList.push("Rate required.");
        }
        if (this.carrierContract.offerRatePerMile == null || this.carrierContract.offerRatePerMile <= 0) {
            this.isValid = false;
            this.validationWarningList.push("Rate/mi required.");
        }
        //if (this.quoteOrderLine.isMacropointRequired && this.macropointLocationProviderId == 0) {
        //    this.isValid = false;
        //    this.validationWarningList.push("Macropoint required.");
        //}
        //if (this.quoteOrderLine.isMacropointRequired && (this.macropointTrackInterval == null || this.macropointTrackInterval == 0)) {
        //    this.isValid = false;
        //    this.validationWarningList.push("Macropoint Track Via required.");
        //}
    }

    public save() {
        this.quoteOrderLine.cost = this.carrierContract.offerRate;
        this.utilService.isLoading = true;
        this.orderService.saveQuoteOrderLine(this.quoteOrderLine).subscribe(result => {
            this.quoteOrderLine = result;
            this.carrierContract.macropointLocationProviderID = this.macropointLocationProviderId;
            this.carrierContract.macropointTrackingOptionID = this.macropointTrackInterval;
            this.cseService.saveCarrierContract(this.carrierContract).subscribe(result2 => {
                this.utilService.isLoading = false;
                console.log("save", this.carrierContract, result);
                if (result2.resultCollection[0].carrierContractID > 0) {
                    this.cancel();
                } else {
                    this.notificationService.showError("Failed to save record.", "ERROR: Failed to Save");
                }
            });
            //if (this.quoteOrderLine.isMacropointRequired == true) {
            //    var trackingOption = this.macropointTrackingOptions.find(t => t.macropointTrackingOptionID == this.macropointTrackInterval);
            //    if (trackingOption != null) {
            //        this.macropointOrder.trackIntervalMinutes = trackingOption!.trackInterval;
            //    }
            //    this.orderService.saveMacropointOrder(this.macropointOrder).subscribe(result2 => {
            //        console.log("saveMacropointOrder", this.macropointOrder, result2);
            //    });
            //}
        });
    }

    public cancel() {
        this.carrierContract = {} as CarrierContract;
        this.onRefresh.emit();
    }
}
